<p>testrender works!</p>
{{renderlog()}}